import api from "./api-service";

const findAllCities = () => {
  return api().get("cities");
};

export { findAllCities };
